module.exports = __webpack_public_path__ + "img/horse-leg.556b8a6b.jpg";